import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import LoginAuthLoader from '../UIComponents/LoginAuthLoader.tsx';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, login } = useContext(AuthContext);

  if (!isAuthenticated) {
    if (sessionStorage.getItem("lu") != null) {
      login(sessionStorage.getItem("lu"), "1111");
      return <LoginAuthLoader />;
    }
    else
      return <Navigate to="/login" />;
  }
  return children;
};

export default PrivateRoute;